export default __webpack_public_path__ + "static/media/Google_Play.84f7eec6.svg";